module.exports = new __parcel__URL__("Aj-BgImg.6df66cf9.jpg").toString();